import styles from '../GenerationWorkspace.module.css';
import type { AttributeTreeNode, GenerationSettings } from '../state/types';
import type { RecommendedKeys } from '../../common/HierarchicalSelect';
import { AttributeNodeEditor } from './AttributeNodeEditor';

/**
 * OEM が追加したトップレベル group 用の汎用アコーディオン (1 group 分)。
 * GenerationWorkspace の JSX からの切り出しで、DOM 構造・クラス名は不変。
 */
export function ExtraGroupSection({
  node,
  order,
  isOpen,
  onToggle,
  settings,
  onAttributeChange,
  recommendedKeysByGroup,
  templateLockClass,
}: {
  node: AttributeTreeNode;
  order: number;
  isOpen: boolean;
  onToggle: () => void;
  settings: GenerationSettings;
  onAttributeChange: (key: string, value: unknown) => void;
  recommendedKeysByGroup: Record<string, RecommendedKeys> | undefined;
  templateLockClass: string;
}) {
  return (
    <div
      className={`accordion-section ${isOpen ? 'accordion-section-open' : ''}${templateLockClass}`}
      style={{ order }}
    >
      <button
        type="button"
        className="accordion-header"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span className="accordion-title">
          <span>{node.label}</span>
        </span>
        <span className={`accordion-icon ${isOpen ? 'accordion-icon-open' : ''}`}>
          {isOpen ? '▼' : '▶'}
        </span>
      </button>
      <div className={`accordion-panel ${isOpen ? 'accordion-panel-open' : 'accordion-panel-closed'}`}>
        <div className={styles.attributeGrid}>
          {(node.children ?? []).map((child) => (
            <AttributeNodeEditor
              key={child.id}
              node={child}
              value={settings.attributes?.[child.key]}
              onChange={onAttributeChange}
              recommendedKeysByGroup={recommendedKeysByGroup}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
